import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, Bot, Building2 } from 'lucide-react';
const features = [{
  icon: ShieldCheck,
  title: 'Verified Properties',
  description: 'Every property is legally verified and documented before listing. No scams, no hidden issues.'
}, {
  icon: Lock,
  title: 'Secure Transactions',
  description: 'Bank-grade security protects every naira of your investment. Escrow services ensure safety.'
}, {
  icon: Bot,
  title: 'AI-Powered Insights',
  description: 'VeriBot AI analyzes market trends to help you find the perfect property match for your budget.'
}, {
  icon: Building2,
  title: 'End-to-End Management',
  description: 'From purchase to property management, we handle maintenance, tenants, and paperwork.'
}];
export function ValueProps() {
  return <section className="bg-[#F8FAFC] py-24 overflow-hidden" data-id="element-119">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-120">
        <div className="text-center mb-16" data-id="element-121">
          <motion.h2 initial={{
          opacity: 0,
          y: 20,
          filter: 'blur(10px)'
        }} whileInView={{
          opacity: 1,
          y: 0,
          filter: 'blur(0px)'
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="text-3xl font-bold tracking-tight text-[#0F1B2D] sm:text-4xl" data-id="element-122">
            Why Choose VeriProp?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          delay: 0.1
        }} className="mt-4 text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-123">
            We've built the most secure and transparent way to invest in
            Nigerian real estate from abroad.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4" data-id="element-124">
          {features.map((feature, index) => <motion.div key={feature.title} initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          type: 'spring',
          stiffness: 50,
          damping: 20,
          delay: index * 0.15
        }} whileHover={{
          y: -5,
          transition: {
            duration: 0.2
          }
        }} className="relative rounded-2xl bg-white p-8 shadow-sm hover:shadow-xl transition-shadow duration-300 border border-slate-100 group" data-id="element-125">
              <div className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#E8531E]/10 text-[#E8531E] group-hover:scale-110 transition-transform duration-300" data-id="element-126">
                <motion.div animate={{
              scale: [1, 1.1, 1]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              repeatDelay: 3 + index
            }} data-id="element-127">
                  <feature.icon className="h-6 w-6" data-id="element-128" />
                </motion.div>
              </div>
              <h3 className="mb-3 text-xl font-bold text-[#0F1B2D]" data-id="element-129">
                {feature.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-130">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}